import { makeAPICall } from "../../utils/common";
import config from "../../utils/config";

export const  GET_DASHBOARD_ACCESSIBILITY_STATUS = "GET_DASHBOARD_ACCESSIBILITY_STATUS";
export const  GET_DASHBOARD_ACCESSIBILITY_STATUS_SUCCESS = "GET_DASHBOARD_ACCESSIBILITY_STATUS_SUCCESS";
export const  GET_DASHBOARD_ACCESSIBILITY_STATUS_FAILED = "GET_DASHBOARD_ACCESSIBILITY_STATUS_FAILED";


export function triggerIsDashboardAccessible(obj, callback){
    return (dispatch) => {
        const params = {
            url: `${config.apiBasePath.baseIp}get-dashboard-user-role-mapping`,   //sending at http://localhost:5000/express/api/api/get-dashboard-user-role-mapping
            dispatch,
            defaultAction: GET_DASHBOARD_ACCESSIBILITY_STATUS,
            successAction: GET_DASHBOARD_ACCESSIBILITY_STATUS_SUCCESS,
            failedAction: GET_DASHBOARD_ACCESSIBILITY_STATUS_FAILED,
            type: "POST",
            headers: obj.headers,
            params: obj.params,
            tab: obj.params.baseParameter.name,
            callback: callback
        };
        makeAPICall(params);
    };
}
